import {Redirect} from 'react-router-dom';
import {getApplicationState, NORMAL, setApplicationState, START_LINK_IDP} from "../services/common";
import {useOktaAuth} from "@okta/okta-react";
import {useIdps} from "../contexts/IdpsContext";
import {useEffect, useState} from "react";

const loginDomain = process.env.REACT_APP_OKTA_DOMAIN;

const HomeView = () => {
    const {authState} = useOktaAuth();
    const {linkIdp} = useIdps();
    const appState = getApplicationState();
    const [holdView, setHoldView] = useState(appState.state);
    const [linking, setLinking] = useState(false);

    useEffect(() => {
        if (authState.isAuthenticated && holdView === START_LINK_IDP && !linking) {
            const idpId = appState?.link?.idpId ?? null;
            const externalId = appState?.link?.externalId ?? null;
            const idpName = appState?.link?.idpName ?? null;
            if (!!idpId && !!externalId) {
                setLinking(true);

                const link = async () => {
                    const success = await linkIdp(idpId, externalId);

                    appState.state = NORMAL;
                    delete appState.link;

                    setApplicationState(appState);

                    if (success) {
                        window.location.replace(`/idp/link/${idpName}/success`);
                    } else {
                        setTimeout(() => {
                            window.location.replace(`https://${loginDomain}`)
                        }, 3000);
                    }
                }

                link().then(_ => {
                })
            } else {
                setHoldView(null)
            }
        }
    }, [appState, authState.isAuthenticated, linkIdp, linking, setLinking, holdView, setHoldView])

    if (authState.isAuthenticated && holdView === START_LINK_IDP) {
        return <></>
    }

    return <Redirect to={'/profile'}/>;
}

export default HomeView;
